import { cn } from "@repo/ui/lib/utils";
import type { ReactNode } from "react";

interface ProjectPageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  className?: string;
  actionsClassName?: string;
}

export function ProjectPageHeader({
  title,
  subtitle,
  children,
  className,
  actionsClassName,
}: ProjectPageHeaderProps) {
  return (
    <div
      className={cn("flex items-center justify-between gap-4 mb-6", className)}
    >
      <div className="flex flex-col min-w-0">
        <h2 className="text-2xl font-bold truncate">{title}</h2>
        {subtitle && (
          <div className="text-sm text-muted-foreground mt-0.5 whitespace-nowrap overflow-hidden text-ellipsis">
            {subtitle}
          </div>
        )}
      </div>
      {children && (
        <div className={cn("flex items-center gap-2", actionsClassName)}>
          {children}
        </div>
      )}
    </div>
  );
}
